import api from "./api";
import { APIS } from "../endpoints";

export const getUniqueDocTypesFromExcel = async () => {
    const result = await api.get(`${APIS.BASE_URL}${APIS.documentTypesUniqueFromExcel}`);
    if (result) {
        return result?.data?.data || [];
    }
    return [];
};


export const getAllDocTypesData = async (limit, page, searchTerm) => {
    const formData = new FormData();
    formData.append('page', page);
    formData.append('limit', limit);

    if (searchTerm) {
        formData.append('search', searchTerm); // Add search term
    }

    const params = new URLSearchParams(formData);
    const result = await api.get(`${APIS.BASE_URL}${APIS.documentTypes}`, {
        params: params
    })

    if (result) {
        return result?.data;
    } else {
        return [];
    }
};

export const getDocTypeData = async (alias) => {
    const endpoint = `${APIS.BASE_URL}${APIS.documentTypes}/${alias}`;

    try {
        const result = await api.get(endpoint);

        // Return the `data` if the result exists, otherwise return an empty array
        return result?.data?.data || [];
    } catch (error) {
        console.error('Error fetching document type data:', error);
        return [];
    }
};

export const updateDocTypeData = async (alias, data, deletedValues) => {

    const payload = {
        ...data,
        deletedValues: deletedValues
    };

    const result = await api.put(`${APIS.BASE_URL}${APIS.documentTypes}/${alias}`, payload)

    if (result) {
        return result?.data;
    } else {
        return [];
    }
};

export const createNewDocType = async (data) => {

    const result = await api.post(`${APIS.BASE_URL}${APIS.documentTypes}`, data)

    if (result) {
        return result?.data;
    } else {
        return [];
    }
}

export const deleteDocTypeSingle = async (alias) => {
    const result = await api.delete(`${APIS.BASE_URL}${APIS.documentTypes}`, { data: { alias } });
    if (result) {
        return result?.data;
    } else {
        return [];
    }
};

export const deleteDocTypesBulk = async (deletedItems) => {
    const result = await api.delete(`${APIS.BASE_URL}${APIS.documentTypes}`, { data: { deletedItems } });
    if (result) {
        return result?.data;
    } else {
        return [];
    }
};